// Shared by the editor preview and public feedback page. No authenticated APIs.
import React from "react";

export const CONTACT_FIELDS = [
  ["telephone", "Site telephone number"],
  ["email", "Site email address"],
  ["pharmacistName", "Pharmacist name"]
];
export const DEFAULT_CONTACT_BLOCKS = Object.fromEntries(CONTACT_FIELDS.map(([key], index) => [key, {
  enabled: false, x: 5, y: 81 + index * 6, w: 90, h: 5,
  fontSize: 14, fg: "#434343", align: "center"
}]));
const bounded = (value, fallback, min, max) => Number.isFinite(Number(value))
  ? Math.max(min, Math.min(max, Number(value))) : fallback;
export function contactHeight(webpage) {
  return bounded(webpage?.contactCanvasHeight, 1100, 800, 2400);
}
export function contactBlock(webpage, key) {
  const b = { ...DEFAULT_CONTACT_BLOCKS[key], ...webpage?.contactBlocks?.[key] };
  const w = bounded(b.w, 90, 6, 100), h = bounded(b.h, 5, 2, 100);
  return { ...b, enabled: b.enabled === true, w, h,
    x: bounded(b.x, 5, 0, 100 - w), y: bounded(b.y, 81, 0, 100 - h),
    fontSize: bounded(b.fontSize, 14, 10, 30),
    align: ["left", "center", "right", "justify"].includes(b.align) ? b.align : "center" };
}
export default function FeedbackContactLayout({ webpage, details = {}, pharmacyName, children }) {
  const fields = CONTACT_FIELDS.filter(([key]) => contactBlock(webpage, key).enabled && details?.[key]);
  const height = contactHeight(webpage);
  const name = webpage?.pharmacyName || {};
  const positioned = name.positioned === true;
  const nameW = bounded(name.w, 60, 6, 100);
  return <div style={{ position: "relative", minHeight: fields.length || positioned ? height : undefined, paddingTop: positioned ? 50 : undefined, boxSizing: "border-box" }}>
    {positioned && pharmacyName && <div style={{ position: "absolute",
      left: `${bounded(name.x, 20, 0, 100 - nameW)}%`, top: height * bounded(name.y, 0, 0, 96) / 100,
      width: `${nameW}%`, fontSize: name.fontSize || 22, fontWeight: 700, color: name.fg || "#262626",
      textAlign: name.align || "center", overflowWrap: "anywhere" }}>{pharmacyName}</div>}
    {children}
    {fields.map(([key, label]) => {
      const b = contactBlock(webpage, key);
      const value = String(details[key]);
      const href = key === "telephone" ? `tel:${value.replace(/[^+\d]/g, "")}`
        : key === "email" ? `mailto:${value}` : null;
      return <div key={key} aria-label={label} style={{ position: "absolute", left: `${b.x}%`,
        top: height * b.y / 100, width: `${b.w}%`, minHeight: height * b.h / 100,
        fontSize: b.fontSize, color: b.fg, textAlign: b.align, overflowWrap: "anywhere" }}>
        {href ? <a href={href} style={{ color: "inherit" }}>{value}</a> : value}
      </div>;
    })}
  </div>;
}
